<div class="ERO" (click)="open()">

  <div class="secction-ERO">
    <img src="assets/images/icons/file_blue.svg" class="archivo" alt="" />
    <span>ERO</span>

  </div>
  <!-- <div style="cursor:pointer;"> -->

  <!-- </div> -->
</div>

<ng-template #contenidoModal>
  <div class="document-viewer-modal">
    <div style="display:flex; justify-content:flex-end;">
      <button mat-icon-button (click)="close()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="text-center">
      <div *ngIf="loadingDoc" class="alert alert-info">
        Descargando documento para previsualizar...
      </div>

      <div *ngIf="!loadingDoc && errorDoc" class="alert alert-danger">
        {{ errorDoc }}
      </div>

      <ng-container *ngIf="!loadingDoc && !errorDoc">
<div class="document-viewer-pdf">
  <app-pdf-canvas-viewer
    *ngIf="pdfSrc"
    [src]="pdfSrc"
    style="display:block; width:100%;">
  </app-pdf-canvas-viewer>
</div>




        <div *ngIf="!pdfSrc" class="alert alert-warning">
          No hay contenido para previsualizar.
        </div>
      </ng-container>

      <div style="margin-top:12px; display:flex; gap:10px; justify-content:center;">
        <button type="button" class="btn btn-secondary" (click)="openInNewTab()" [disabled]="!pdfSrc">
          Abrir
        </button>

        <button type="button" class="btn btn-primary" (click)="download()" [disabled]="!pdfSrc">
          Descargar
        </button>
      </div>
    </div>
  </div>
</ng-template>


